import React from 'react';
import useMediaPreview from './useMediaPreview';
import { Container } from './styles/index';
import MediaGridView from './MediaGridView';
import ProcessingView from './ProcessingView';
import MediaModal from './MediaModal';
/**
 * 미디어 프리뷰 컴포넌트
 * 이미지와 비디오 미리보기를 담당하는 컨테이너
 */ export default function MediaPreview(param) {
    var media = param.media, onRemove = param.onRemove, _param_isSubmitting = param.isSubmitting, isSubmitting = _param_isSubmitting === void 0 ? false : _param_isSubmitting;
    var _useMediaPreview = useMediaPreview({
        media: media,
        onRemove: onRemove,
        isSubmitting: isSubmitting
    }), hoveredIndex = _useMediaPreview.hoveredIndex, setHoveredIndex = _useMediaPreview.setHoveredIndex, isModalOpen = _useMediaPreview.isModalOpen, activeModalIndex = _useMediaPreview.activeModalIndex, setActiveModalIndex = _useMediaPreview.setActiveModalIndex, displayableMedia = _useMediaPreview.displayableMedia, getGridClass = _useMediaPreview.getGridClass, getItemClass = _useMediaPreview.getItemClass, handleMediaClick = _useMediaPreview.handleMediaClick, handleCloseModal = _useMediaPreview.handleCloseModal, handleNextImage = _useMediaPreview.handleNextImage, handlePrevImage = _useMediaPreview.handlePrevImage, hasProcessingMedia = _useMediaPreview.hasProcessingMedia, processingMedia = _useMediaPreview.processingMedia;
    if (!(media === null || media === void 0 ? void 0 : media.length)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(MediaGridView, {
        media: media,
        displayableMedia: displayableMedia,
        hoveredIndex: hoveredIndex,
        setHoveredIndex: setHoveredIndex,
        getGridClass: getGridClass,
        getItemClass: getItemClass,
        handleMediaClick: handleMediaClick,
        onRemove: onRemove,
        isSubmitting: isSubmitting
    }), hasProcessingMedia && /*#__PURE__*/ React.createElement(ProcessingView, {
        processingMedia: processingMedia,
        onRemove: onRemove,
        isSubmitting: isSubmitting
    }), /*#__PURE__*/ React.createElement(MediaModal, {
        isOpen: isModalOpen,
        displayableMedia: displayableMedia,
        activeIndex: activeModalIndex,
        setActiveIndex: setActiveModalIndex,
        onClose: handleCloseModal,
        onNext: handleNextImage,
        onPrev: handlePrevImage
    }));
}
